// extracted by mini-css-extract-plugin
export default {"container":"kM06k","amount":"lJZ5j","tooltip":"V0ZZ5","tooltipIcon":"omate"};